import React, { useMemo } from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { connect } from "react-redux";
import { isLoading } from "@worcket/common/hocs";

import { FETCH_TESTS } from "../../store/actions/catalogs";
import Button from "../Button";

import styled from "styled-components/macro";

const Wrapper = styled.div`
  text-align: center;
  margin: 16px 0;
`;

function HumanTestMessage({
  message: { widgetMetadata },
  candidate: { humanTests = [], tests = [] },
  match,
  history,
  tests: allTests = [],
  t
}) {
  const testMetadata = useMemo(() => {
    return allTests.find(
      ({ type, testId }) =>
        type &&
        testId &&
        widgetMetadata.source &&
        widgetMetadata.idTest &&
        type === widgetMetadata.source &&
        testId === widgetMetadata.idTest
    );
  }, [allTests, widgetMetadata.idTest, widgetMetadata.source]);

  if (!testMetadata)
    return <Wrapper>{t("process.stepTypes.test.retrievingError")}</Wrapper>;

  const userTest =
    widgetMetadata.completed ||
    [...humanTests, ...tests].find(
      ({ source, testIdentifier, serviceCallResult }) =>
        source === testMetadata.type &&
        testIdentifier === testMetadata.testId &&
        serviceCallResult === "success"
    );

  if (!userTest) {
    return (
      <Wrapper>
        {`${t("process.stepTypes.test.missingTest")}${t(
          `opportunity:process.candidateDetails.${testMetadata.key}.title`
        )}.`}
      </Wrapper>
    );
  }

  const navigateToTest = () => {
    history.push(
      match.url.replace(
        "/chat",
        `/tests/${t(
          `opportunity:process.candidateDetails.${testMetadata.key}.slug`
        )}`
      )
    );
  };

  return (
    <Wrapper>
      {`${t("process.stepTypes.test.doneTest")}${t(
        `opportunity:process.stepTypes.test.${widgetMetadata.idTest}.title`
      )}. `}
      <Button
        style={{ marginLeft: 15 }}
        type="primary"
        onClick={navigateToTest}
      >
        {t("process.stepTypes.test.seeResults")}
      </Button>
    </Wrapper>
  );
}

export default compose(
  isLoading(FETCH_TESTS),
  connect(state => ({
    tests: FETCH_TESTS.getResponse(state)
  })),
  withRouter,
  withTranslation(["opportunity"])
)(HumanTestMessage);
